import { Drawer } from '@/components/modules';
import useLogin from '@/hooks/useLogin';
import { useMeQuery } from '@/remote/user-management/fetch-me';
import { ROUTES } from '@/router/routes';

interface NavigationDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

interface MenuItem {
  icon: string;
  label: string;
  href: string;
}

export default function NavigationDrawer({
  isOpen,
  onClose,
}: Readonly<NavigationDrawerProps>) {
  const { logout } = useLogin();
  const { data: me } = useMeQuery();

  const menuItems: MenuItem[] = [
    {
      icon: 'ri-map-pin-line',
      label: '현장 정보',
      href: ROUTES.SITE_INFORMATION,
    },
  ];

  if (
    me.userLevel === 'SUPER_ADMINISTRATOR' ||
    me.userLevel === 'HEADQUARTERS_MANAGER' ||
    me.userLevel === 'PUBLIC_OFFICE_MANAGER'
  ) {
    menuItems.push({
      icon: 'ri-settings-line',
      label: '현장 관리',
      href: ROUTES.SITE_MANAGEMENT,
    });
  }

  if (
    me.userLevel === 'SUPER_ADMINISTRATOR' ||
    me.userLevel === 'HEADQUARTERS_MANAGER'
  ) {
    menuItems.push({
      icon: 'ri-user-line',
      label: '회원 관리',
      href: ROUTES.USER_MANAGEMENT,
    });
  }

  if (me.userLevel === 'SUPER_ADMINISTRATOR') {
    menuItems.push({
      icon: 'ri-database-2-line',
      label: 'RAW 데이터',
      href: ROUTES.RAW_DATA,
    });
  }

  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      title="메뉴"
      position="left"
      width="w-64"
    >
      <nav className="space-y-2">
        {menuItems.map((item, index) => (
          <a
            key={index}
            href={item.href}
            className="flex items-center space-x-3 px-4 py-3 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors group"
            onClick={onClose}
          >
            <div className="w-5 h-5 flex items-center justify-center text-gray-500 group-hover:text-blue-600">
              <i className={item.icon}></i>
            </div>
            <span className="font-medium group-hover:text-gray-900">
              {item.label}
            </span>
          </a>
        ))}
      </nav>

      <div className="mt-8 pt-8 border-t border-gray-200">
        <div className="space-y-2">
          <a
            href="/settings"
            className="flex items-center space-x-3 px-4 py-3 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors group"
            onClick={onClose}
          >
            <div className="w-5 h-5 flex items-center justify-center text-gray-500 group-hover:text-blue-600">
              <i className="ri-settings-3-line"></i>
            </div>
            <span className="font-medium group-hover:text-gray-900">설정</span>
          </a>

          <button
            className="w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-gray-700 hover:bg-red-50 transition-colors group"
            onClick={() => {
              onClose();
              logout();
            }}
          >
            <div className="w-5 h-5 flex items-center justify-center text-gray-500 group-hover:text-red-600">
              <i className="ri-logout-box-line"></i>
            </div>
            <span className="font-medium group-hover:text-red-900">
              로그아웃
            </span>
          </button>
        </div>
      </div>
    </Drawer>
  );
}
